module.exports = __webpack_public_path__ + "static/img/news-album.d3845b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images-en/news-album.png
// module id = RhSr
// module chunks = 1